<template>
    <div v-show="!this.$store.state.load" class="anuncio">
        <div class="topo">
            <nav>
                <img class="logo" src="../assets/images/planti-logo.svg" alt="">
            </nav>
        </div>
        <!--corpo caso exista anúncio-->
        <div v-if="this.$store.state.existes" class="corpo container">
            <div class="row mx-3">
                <!--Dados Anuncio-->
                <div class="col ">
                    <!--titulo-->
                    <div class="row">
                        <label class="titulo">{{dadosAnuncio.titulo}}</label>
                    </div>
                    <!--data publicação-->
                    <div class="row">
                        <label class="dt-publicacao">{{ dataCriacao }}</label>
                    </div>
                    <!--imagens-->
                    <carousel-custom/>
                    <!--preco-->
                    <div class="row">
                        <label class="preco">{{ preco }}</label>
                    </div>
                    <!--descrição-->
                    <div class="row">
                        <label class="descricao">{{ dadosAnuncio.descricao }}</label>
                    </div>
                    <!--botões-->
                    <div class="row btns">
                        <div class="col-md-auto col-sm-12 m-0 p-0">
                            <button @click="share()" class="btn btn-block btn-sm mr-4"><img width="18" class="mr-2" style="margin-top: -1px" src="../assets/images/compartilhar.svg" alt="">Compartilhar</button>
                        </div>
                        <div class="col-md-auto col-sm-12 m-0 p-0">
                            <a href="https://planti.page.link/app" target="_blank" class="btn btn-sm mr-4"><img width="18" class="mr-2" style="margin-top: -1px" src="../assets/images/device.svg" alt="">Abrir app</a>
                        </div>
                        <div class="col-md-auto col-sm-12 m-0 p-0">
                            <button disabled class="btn btn-sm"><img width="18" class="mr-2" style="margin-top: -1px" src="../assets/images/denunciar.svg" alt="">Denunciar</button>
                        </div>
                    </div>
                    <div class="row linha"></div>
                    <div class="row">
                        <label class="localizacao">Localização</label>
                    </div>
                    <div class="row">
                        <div class="col-md-4 col-12">
                            <div class="row">
                                <div class="col-md-12 col-6 mx-0 px-0"><label class="tex1">Cep</label></div>
                                <div class="col-md-12 col-6 mx-0 px-0"><label class="tex2">{{ dadosAnuncio.cep }}</label></div>
                            </div>
                        </div>
                        <div class="col-md-4 col-12">
                            <div class="row">
                                <div class="col-md-12 col-6 mx-0 px-0"><label class="tex1">Município</label></div>
                                <div class="col-md-12 col-6 mx-0 px-0"><label class="tex2">{{ dadosAnuncio.cidade }}</label></div>
                            </div>
                        </div>
                        <div class="col-md-4 col-12">
                            <div class="row">
                                <div class="col-md-12 col-6 mx-0 px-0"><label class="tex1">Bairro</label></div>
                                <div class="col-md-12 col-6 mx-0 px-0"><label class="tex2">{{ dadosAnuncio.bairro }}</label></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--barra lateral/dados pessoais-->
                <div class="col-lg-3 col-md-12 col-sm-12  px-0 mx-0">
                    <div class="row caixa-verd-valor px-0 mx-0 mb-4" style="border-radius: 10px">
                        <div class="col-12">
                            <label>{{ preco }}</label>
                        </div>
                    </div>
                    <div class="row caixa-chat px-0 mx-0 mb-4">
                        <div class="col-12 text-center">
                            <div class="row">
                                <div class="col-12 mt-4">
                                    <label class="t1">{{ nome }}</label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 mt-3">
                                    <button disabled class="btn btn-sm btn-success"><img width="18" class="mr-2" style="margin-top: -1px" src="../assets/images/chat.svg" alt="">Chat</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 mt-3">
                                    <label class="t2">{{ ultimoAcesso }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Anuncio-->
                    <div v-if="false" class="row px-0 mx-0">
                        <div class="col-12 px-0 mx-0">
                            <img style="width: 100%;" class="p-0 m-0" src="../assets/images/anuncio_disney.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--corpo erro na página-->
        <div v-else class="corpo container-fluid" style="display:flex; flex-direction:column; justify-content:center;">
            <div class="row ">
                <div class="col-12 text-center">
                    <img class="" src="../assets/images/emptystate.svg" style="margin-top: -35px" alt="">
                    <label class="descricao" style="width: 100%; text-align: center; font-weight: 600; font-size: 24px; margin-top: -15px">Página não encontrada</label>
                </div>
            </div>

        </div>
        <div class="rodape">
            <div class="bg-verde">
                <div class="footer-conteudo row mx-0">
                    <div class="col-md-7 col-lx-6 div1-footer">
                        <div class="row mb-1">
                            <div class="col-12 mx-0 px-0">
                                <label class="t1-footer">Baixe nosso aplicativo:</label>
                            </div>
                        </div>
                        <div class="row">
                            <a class="loja1-footer" href="https://apps.apple.com/br/app/planti/id1533612038" target="_blank"><img class="mr-4" src="../assets/images/app-store.svg" alt=""></a>
                            <a class="loja2-footer" href="https://play.google.com/store/apps/details?id=com.misie.planti" target="_blank"><img class="loja2" src="../assets/images/google-play.svg" alt=""></a>
                        </div>
                    </div>
                    <div class="linha-footer" style="display: none"></div>
                    <div class="col-md-4 col-lx-6 pt-4 pr-5">
                        <a class="social1-footer" style="float: right" href="https://www.instagram.com/plantiapp/" target="_blank"><img width="40" src="../assets/images/insta.svg" alt=""></a>
                        <a class="social2-footer" style="float: right" href="https://www.facebook.com/Planti-App-118228620091995/" target="_blank"><img width="40" class="mr-4" src="../assets/images/face.svg" alt=""></a>
                    </div>
                </div>
            </div>
        </div>
        <div :style="popupVisible" class="popup-inicial">
            <div class="fundo"></div>
            <div class="card-popup text-center">
                <div class="row fechar-card">
                    <div class="col-12 text-right font-weight-bold mt-3" style="margin-right: 200px !important; cursor: pointer">
                        <span @click="ocultarPopup" class="mr-4 px-2">X</span>
                    </div>
                </div>
                <div class="row titulo-card">
                    <div class="col-12">
                        <label>GOSTARIA DE ABRIR ESTE ANÚNCIO NO PLANTI?</label>
                    </div>
                </div>
                <div class="row descricao-card">
                    <div class="col-12">
                        <label>Baixe nosso aplicativo e tenha uma experiência completa.</label>
                    </div>
                </div>
                <div class="btns-card">
                    <div class="row">
                        <div class="col-12">
                            <a href="https://planti.page.link/app" @click="ocultarPopup" target="_blank" class="btn btn-sm btn-success">Abrir App</a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <button @click="ocultarPopup" class="btn btn-sm btn-link">mais tarde</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import CarouselCustom from "@/components/carousel/index";
import { mapState } from 'vuex'

export default {
    name: 'Anuncio',
    components: {CarouselCustom},
    data() {
        return {
            idAnuncio: '',
            loading: false,
            popupVisible: {display: 'block'}
        }
    },
    async beforeCreate() {
        if (this.$route.query.id === ''){
            this.$store.state.existes = false
            this.$store.state.load = false
            return false
        }
        await this.$store.dispatch('getDadosAnuncio', {
            id: this.$route.query.id
        })
    },
    methods:{
        ocultarPopup (){
            this.popupVisible.display = 'none'
        },
        share(){
            if (navigator.share !== undefined) {
                navigator.share({
                    title: this.dadosAnuncio.titulo,
                    text: this.dadosAnuncio.descricao,
                    url: 'http://www.misie.com.br/planti/anuncio?id='+this.$route.query.id,
                })
            }
        }
    },
    computed: {
        ...mapState(['dadosAnuncio']),
        preco: function (){
            let label = ''
            if (this.dadosAnuncio.tipo_negocio === 'Venda')
                label = 'R$ '+ this.dadosAnuncio.preco
            else if (this.dadosAnuncio.tipo_negocio === 'Troca') label = 'Troca'
            return label
        },
        dataCriacao: function (){
            if (!this.dadosAnuncio.data) return ''
            let data = this.dadosAnuncio.data.toDate()
            let dia = data.getDate()
            let mes = data.getMonth()
            let horas = data.getHours()
            if (dia < 10) dia = '0' + dia
            if (mes < 10) mes = '0' + mes
            if (horas < 10) horas = '0' + horas
            data = 'Publicado em '+dia + '/' + mes + ' às ' + horas + ':' + data.getMinutes()
            return data
        },
        nome: function (){
            if (!this.dadosAnuncio.public_data) return ''
            return this.dadosAnuncio.public_data.nome
        },
        ultimoAcesso: function (){
            if (!this.dadosAnuncio.public_data) return ''
            let data = this.dadosAnuncio.public_data.visto_ultimo.toDate()
            let dia = data.getDate()
            let mes = data.getMonth()
            let horas = data.getHours()
            if (dia < 10) dia = '0' + dia
            if (mes < 10) mes = '0' + mes
            if (horas < 10) horas = '0' + horas
            data = 'Último acesso em '+dia + '/' + mes + ' às ' + horas + ':' + data.getMinutes()
            return data
        },
    }
}
</script>

<style lang="scss" scoped>

.popup-inicial{
    z-index: 50;
    display: flex;
    align-items: center;
    align-content: center;
}
.fundo{
    z-index: 49;
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background: #4F4F4F;
    opacity: 0.5;
}
.card-popup{
    z-index: 50;
    background-color: white;
    width: 480px;
    height: 500.11px;
    left: calc(50% - 480px/2);
    top: calc(50% - 568.11px/2 + 0.56px);
    border-radius: 24px;
    position: fixed;
}
.titulo-card label{
    margin-top: 38px;
    width: 350px;
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 43px;
    text-align: center;
    letter-spacing: 1px;
    color: #14142B;
    flex: none;
    order: 0;
    flex-grow: 0;
}
.descricao-card label{
    //background-color: #00BA88;
    margin-top: 15px;
    width: 300px;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 31px;
    text-align: center;
    letter-spacing: 0.75px;
    color: #4E4B66;
    flex: none;
    order: 1;
    flex-grow: 0;
}
.btns-card .btn-success{
    margin-top: 17px;
    height: 42px;
    background: #27AE60;
    border-radius: 28px;
    padding-left: 50px;
    padding-top: 9px;
    padding-right: 50px;
}
.btns-card .btn-link{
    margin-top: 15px;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    text-align: center;
    letter-spacing: 0.75px;
    text-decoration: none;
    color: #4E4B66;
    flex: none;
    order: 3;
    flex-grow: 0;
}

.anuncio, .corpo {
    min-height: calc(100vh - 190px - 60px);
    position: relative !important;
}

.rodape {
    position: relative;
    bottom: 0;
    width: 100%;
}


.anuncio {
    margin: 0;
    padding: 0;
}
.topo{
    background-color: white;
    width: 100%;
    height: 60px;
}
.logo{
    margin-top: 2px;
    width: 100px;
}
nav{
    padding: 10px 100px;
}

.corpo{
    padding-top: 70px;
    padding-bottom: 70px;
}
@media (max-width: 992px) {
    .corpo{
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .footer-conteudo{
        padding: 50px 50px !important;
        width: 100%;
    }
}
@media (max-width: 768px) {
    .corpo{
        padding-top: 30px;
        padding-bottom: 30px;
    }
    .corpo .btns .btn{
        width: 100% !important;
    }
    nav{
        padding: 10px 30px !important;
    }
    .bg-verde{
        display: flex;
        align-content: center;
        align-items: center;
        flex-direction: column;
        height: 225px !important;
        overflow: hidden !important;
    }
    .footer-conteudo{
        position: absolute;
        width: 360px !important;
        margin: 0 auto !important;
        padding: 0 !important;
    }
    .t1-footer{
        display: flex;
        position: absolute !important;
        //font-size: 22px !important;
        left: 38px;
        top: 10px;
    }
    .loja1-footer{
        position: absolute !important;
        left: 42px;
        top: 55px;
    }
    .loja2-footer{
        position: absolute !important;
        left: 185px;
        top: 55px;
    }
    .linha-footer{
        display: block !important;
        position: absolute;
        left: 77px;
        top: 120px;
        width: 214px;
        background-color: #ffffff99;
        height: 1px;
    }

    .social1-footer{
        position: absolute !important;
        left: 115px;
        top: 140px;
    }
    .social2-footer{
        position: absolute !important;
        left: 198px;
        top: 140px;
    }

    .div1-footer{
        position: absolute;
    }


    ///////POP POP * *
    .card-popup{
        width: 100%;
        height: 440px;
        left: 0;
        bottom: -30px;
        top: unset;
        border-radius: 24px;
        position: fixed;
    }

    .titulo-card label{
        margin-top: 23px;
        width: 300px;
        font-size: 25px;
        line-height: 38px;
    }

    .descricao-card label{
        font-size: 16px;
        line-height: 28px;
    }

    .btns-card .btn-success{
        margin-top: 17px;
        height: 42px;
        background: #27AE60;
        border-radius: 28px;
        padding-left: 50px;
        padding-top: 9px;
        padding-right: 50px;
    }
    .btns-card .btn-link{
        margin-top: 15px;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 28px;
        text-align: center;
        letter-spacing: 0.75px;
        text-decoration: none;
        color: #4E4B66;
        flex: none;
        order: 3;
        flex-grow: 0;
    }

}

.rodape{
    width: 100%;
}
.bg-verde{
    width: 100%;
    height: 190px;
    background: linear-gradient(258.32deg, #93F9B9 0%, #1D976C 99.73%);
}
.footer-conteudo{
    padding: 50px 120px;
    width: 100%;
}
.t1-footer{
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 38px;
    display: flex;
    align-items: center;
    letter-spacing: 0.75px;
    color: #F2F2F2;
}

.linha{
    width: 208px;
    border: 1px solid #82828299;
    margin-bottom: 28px;
}

.caixa-verd-valor{
    margin-right: 0;
    padding-right: 0;
    width: 100%;
    height: 70px;
    background: #27AE60;
    border-radius: 15px;
}
.caixa-verd-valor label{
    float: right;
    padding: 17px 0;
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 34px;
    letter-spacing: 1px;
    color: #F2F2F2;
}
.caixa-chat{
    width: 100%;
    height: 264px;
    background: #F2F2F2;
}
.caixa-chat .t1{
    font-style: normal;
    font-weight: 600;
    font-size: 23px;
    line-height: 38px;
    letter-spacing: 0.75px;
    color: #4F4F4F;
}
.caixa-chat .btn{
    width: 143px;
    height: 40px;
    //border: 1px solid #27AE60;
    //color: #27AE60;
    background: #27AE60;
    border-radius: 32px;
}
.caixa-chat .t2{
    font-style: normal;
    font-weight: 500;
    font-size: 13.5px;
    line-height: 24px;
    letter-spacing: 0.75px;
    color: #828282;
}

.titulo{
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    line-height: 34px;
    letter-spacing: 1px;
    color: #000000;
}
.dt-publicacao{
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 34px;
    letter-spacing: 0.75px;
    color: #828282;
}
.preco{
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 38px;
    letter-spacing: 0.75px;
    color: #000000;
}
.descricao{
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 34px;
    letter-spacing: 0.75px;
    color: #4F4F4F;
}
.corpo .btns .btn{
    width: 164px;
    height: 37px;
    border: 1px solid #27AE60;
    box-sizing: border-box;
    border-radius: 32px;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    padding-top: -4px !important;
    //display: flex;
    //align-items: center;
    //text-align: center;
    letter-spacing: 0.002em;
    color: #27AE60;
    margin-top: 5px;
    margin-bottom: 5px;
}
.btns{
    margin-top: 15px;
    margin-bottom: 35px;
}

.localizacao{
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 34px;
    letter-spacing: 0.75px;
    color: #000000;
}

.tex1{
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;
    letter-spacing: 0.75px;
    color: #828282;
}
.tex2{
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.75px;
    color: #828282;
}

</style>
